import React from 'react';
import ProfileMeta from 'profile/containers/profile_meta';
import Languages from 'profile/containers/languages';
import Specializations from 'profile/containers/specializations';
import Social from 'profile/containers/social';
import Testimonials from 'profile/containers/testimonials';
import About from 'profile/containers/about';
import AllStats from 'profile/containers/all_stats';
import ProfileBackground from 'profile/containers/profile_background';
import ActiveProjects from 'profile/containers/projects';
import CompletedProjects from 'profile/containers/completed_projects';
import CreativeMenu from 'profile/containers/creative_menu';

const UserProfile = () => (
  <div id="content" className="profile-content">
    <div className="cover-photo">
      <ProfileBackground />
    </div>
    <div className="row">
      <aside className="small-16 medium-4 column">
        <ProfileMeta />
        <Specializations />
        <Languages />
        <Social />
      </aside>
      <div className="small-16 medium-12 column">
        <AllStats />
        <div className="show-for-small-only">
          <CreativeMenu />
        </div>
        <Testimonials />
        <About />
        <ActiveProjects />
      </div>
    </div>
    <CompletedProjects />
  </div>
);

export default UserProfile;



// WEBPACK FOOTER //
// ./profile/components/view.jsx